import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash"
import {FulfillmentSubTypeType} from "../../types/fulfillment-sub-type.type";

export class FulfillmentLineAttemptsInfoTableRowComponent implements IController {

  attempt: any;
  attemptNumber: any;
  isFirst: boolean;
  isLast: boolean;
  onOpenAttemptInfoDialog: Function;


  public numberOfPodsInAttempt: number = 0;
  public numberOfPodsInAttemptIsDone: number = 0;
  public isAllPodsDone: boolean = false;
  public fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;

  constructor() {
  }

  $onInit() {
    this.initAttemptPodsData(this.attempt);
  }

  private initAttemptPodsData(attempt) {
    this.numberOfPodsInAttempt = 0;
    this.numberOfPodsInAttemptIsDone = 0;
    const attemptTasks = [];

    if (!_.isUndefined(attempt.serviceAttemptInfo.pickupTaskInfo.identifications)) {
      attemptTasks.push(attempt.serviceAttemptInfo.pickupTaskInfo);
    }
    if (!_.isUndefined(attempt.serviceAttemptInfo.destinationTaskInfo.identifications)) {
      attemptTasks.push(attempt.serviceAttemptInfo.destinationTaskInfo);
    }

    _.forEach(attemptTasks, task => {

      if (task.identifications.leaveNextToDoor) {
        this.numberOfPodsInAttempt += 1;
      }
      if (task.identifications.photographIdCard) {
        this.numberOfPodsInAttempt += 1;
      }
      if (task.identifications.photographPerson) {
        this.numberOfPodsInAttempt += 1;
      }
      if (task.identifications.showIdCard) {
        this.numberOfPodsInAttempt += 1;
      }
      if (task.identifications.signature) {
        this.numberOfPodsInAttempt += 1;
      }
      if (task.identifications.visitSummary) {
        this.numberOfPodsInAttempt += 1;
      }
      if (task.identifications.validateAge) {
        this.numberOfPodsInAttempt += 1;
      }

      if (task.identifications.photographLeaveNextToDoorDone) {
        this.numberOfPodsInAttemptIsDone += 1;
      }
      if (task.identifications.photographIdCardDone) {
        this.numberOfPodsInAttemptIsDone += 1;
      }
      if (task.identifications.photographPersonDone) {
        this.numberOfPodsInAttemptIsDone += 1;
      }
      if (task.identifications.validateIdCardNumber) {
        this.numberOfPodsInAttemptIsDone += 1;
      }
      if (task.identifications.signatureDone) {
        this.numberOfPodsInAttemptIsDone += 1;
      }
      if (task.identifications.visitSummaryDone) {
        this.numberOfPodsInAttemptIsDone += 1;
      }
      if (task.identifications.validateAgeDone) {
        this.numberOfPodsInAttemptIsDone += 1;
      }
    })

    this.isAllPodsDone = (this.numberOfPodsInAttemptIsDone / this.numberOfPodsInAttempt) === 1;

  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineAttemptsInfoTableRow', {
    bindings: {
      attempt: '<',
      attemptNumber: '<',
      isFirst: '<',
      isLast: '<',
      onOpenAttemptInfoDialog: '&'
    },
    template: require('./fulfillment-line-attempts-info-table-row.html').default,
    controller: FulfillmentLineAttemptsInfoTableRowComponent
  });
